/**
 * Static helpers shared across the filter card's pieces. Not `@Injectable` — `FilterCardManager` is
 * a plain class (`new`-ed by a resolver, not DI-managed), so it needs to reach this the same way
 * `FilterCardFieldInputComponent`/`FilterCardComponent` do: a direct static call, matching the
 * `DateUtilitiesService` convention already used elsewhere in this codebase.
 */
export class FilterCardService {
  /** `null`/`undefined`/an empty array all mean "no value" — the field's chip should not exist. */
  public static hasFilterCardValue(value: unknown): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    return Array.isArray(value) ? value.length > 0 : true;
  }
}
